<script setup lang="ts">
import { ref } from 'vue'
import { useNotification } from '@kyvg/vue3-notification'
import { apiPost } from '@/lib/http'

const { notify } = useNotification()

interface DetachStudent {
  id: number
  first_name: string
  last_name: string
}

interface DetachTeacher {
  user_id: number
  first_name: string
  last_name: string
}

const student = ref<DetachStudent | null>(null)
const teacher = ref<DetachTeacher | null>(null)
const open = ref(false)
const fetching = ref(false)

function $open(studentValue: DetachStudent, teacherValue: DetachTeacher) {
  student.value = studentValue
  teacher.value = teacherValue
  open.value = true
  fetching.value = false
}

function close() {
  student.value = null
  teacher.value = null
  open.value = false
}

async function doDetach() {
  if (!student.value || !teacher.value) return

  fetching.value = true
  try {
    const { failed, message } = await apiPost('/parent/request_detach_teacher', {
      student_id: student.value.id,
      teacher_id: teacher.value.user_id
    })

    if (failed) throw message

    window.location.reload()
  } catch (err) {
    console.error(err)
    let title = 'Произошла ошибка при откреплении от учителя. Повторите попытку позже.'
    if (typeof err === 'string') title = err

    notify({ type: 'error', title })
  }
  fetching.value = false
}

defineExpose({ $open })
</script>

<template>
  <v-rich-modal title="Открепиться от учителя?" :model-value="open" @update:model-value="close">
    <div v-if="student && teacher" class="parent-detach-teacher-modal">
      <p>
        Профиль ученика
        <b>{{ student.last_name }} {{ student.first_name }}</b>
        будет откреплён от учителя:
      </p>

      <p class="text-title mt-2">{{ teacher.last_name }} {{ teacher.first_name }}</p>

      <p class="mt-2">
        Для корректного отображения отчётов об успеваемости ученика, рекомендуем вам прикрепиться к учителю, с которым
        вы в настоящее время занимаетесь.
      </p>
    </div>

    <template #actions>
      <v-button mode="large outlined block" :disabled="fetching" @click="close"> Отмена </v-button>
      <v-button mode="large error filled block" :disabled="fetching" @click="doDetach"> Открепиться </v-button>
    </template>
  </v-rich-modal>
</template>

<style lang="scss">
.parent-detach-teacher-modal {
  @include desktop {
    max-width: 450px;
  }
}
</style>
